import { useNavigate } from "react-router-dom";
import { useBalanceStore } from "../../_store/balanceStore";
import { CardGrayMenu } from "../../components/card/CardMain";
import { HeaderTitle } from "../../components/header/Header";
import ClearDataButton from "../../components/button/ClearDataButton";
import { useInsuranceStore } from "../../_store/insuranceStore";
import Container from "../../components/layout/Container";
import { NavigatePath } from "../../functions/Navigate.Goback";
import {
  STYLE_MARGIN_TOP_PARENT,
  STYLE_PADDING_MAIN,
  STYLE_SPACE_GRAY_MENU,
} from "../../utils/useStyle";
import { HealthCheckPDF } from "../../functions/pdfGenerateFunction/riskManagePDF";
import numeral from "numeral";

const InsuarancePlanMain = () => {
  const navigate = useNavigate();
  const balanceData = useBalanceStore((state) => state.balanceData);
  const clearInsuranceData = useInsuranceStore((state) => state.clearInsuranceData);

  const onClickToWebsite = () => {
    window.open("https://assurewealth.co.th/", "_blank");
  };

  const hasAccidentInsurance = balanceData?.expenses_fixed_list?.some(
    (thisItem) =>
      thisItem?.options_expenses_fixed === "expenses_insuarant_accident"
  );
  const hasFireInsurance = balanceData?.expenses_fixed_list?.some(
    (thisItem) => thisItem?.options_expenses_fixed === "expenses_insuarant_fire"
  );
  const hasCarInsurance = balanceData?.expenses_fixed_list?.some(
    (thisItem) => thisItem?.options_expenses_fixed === "expenses_insuarant_car"
  );

  return (
    <Container>
      <div id="first_reload" className="">
        <div className={`${STYLE_MARGIN_TOP_PARENT} `}>
          <HeaderTitle
            title="วางแผนประกัน"
            isGoback
            onClickGoBack={() => {
              NavigatePath(navigate, "/");
            }}
            rightContent={<ClearDataButton planName="แผนประกัน" onClear={() => { clearInsuranceData(); window.location.reload(); }} />}
          />
          <div className={`${STYLE_SPACE_GRAY_MENU} ${STYLE_PADDING_MAIN}`}>
            <CardGrayMenu
              img={"../images/homewithheart.png"}
              title={"ประกันคุ้มครองค่าใช้จ่ายเพื่อการดำรงชีพของครอบครัว"}
              onClick={() => {
                navigate("/insuranceplan/family");
              }}
            />
            <CardGrayMenu
              img={"../images/risk_diabled.svg"}
              title={"ประกันคุ้มครองกรณีทุพพลภาพ"}
              title2={
                Number(
                  HealthCheckPDF(balanceData)?.contract_tpd +
                    HealthCheckPDF(balanceData)?.aia_mutiplay_ci_more +
                    HealthCheckPDF(balanceData)?.aia_total_care_more +
                    HealthCheckPDF(balanceData)?.compensation_ecir +
                    HealthCheckPDF(balanceData)?.compensation_aia_supercare +
                    HealthCheckPDF(balanceData)?.compensation_aia_procare +
                    HealthCheckPDF(balanceData)?.compensation_aia_ci_plus_gold +
                    HealthCheckPDF(balanceData)?.compensation_aia_ci_plus +
                    HealthCheckPDF(balanceData)?.compensation_aia_ci_topup +
                    HealthCheckPDF(balanceData)?.compensation_mutiple_care_ci +
                    HealthCheckPDF(balanceData)
                      ?.critical_illness_insurance_yearly_ci
                ) <= 0 ? (
                  <>
                    <div className="text-start">
                      {`คุณลืมกรอกข้อมูลค่าเบี้ยประกันชีวิตหรือไม่ ถ้าคุณไม่ได้ซื้อประกันสุขภาพ หากเกิดเหตุไม่คาดฝันขึ้นมา เจ็บป่วยครั้งเดียวแทบหมดตัว  เบี้ยประกันสุขภาพหลักพัน คุ้มครองหลักแสน เบี้ยประกันหลักหมื่นคุ้มครองหลักล้าน`}
                    </div>
                    <div>{`**กรอกข้อมูลได้ที่รายจ่ายคงที่ > ค่าเบี้ยประกันชีวิตรายปี > รายละเอียดเพิ่มเติม > ตามข้อมูลที่มีดอกจัน 1 ดอก**`}</div>
                  </>
                ) : (
                  <div className="flex flex-col items-start ">
                    <div className="!font-medium ">{`สัญญาเพิ่มเติมกรณีทุพพลภาพ (TPD) ${numeral(
                      HealthCheckPDF(balanceData)?.contract_tpd
                    ).format("0,0")} บาท   `}</div>{" "}
                    <div className="!font-medium ">
                      {`
                สัญญาเพิ่มเติม เอไอเอ มัลติเพย์ ซีไอ ${numeral(
                  HealthCheckPDF(balanceData)?.aia_mutiplay_ci_more
                ).format("0,0")} บาท `}{" "}
                    </div>{" "}
                    <div className="!font-medium ">
                      {`
                สัญญาเพิ่มเติม เอไอเอ โทเทิล แคร์ ${numeral(
                  HealthCheckPDF(balanceData)?.aia_total_care_more
                ).format("0,0")} บาท `}{" "}
                    </div>{" "}
                    <div className="!font-medium ">
                      {`
                ค่าชดเชยโรคร้ายแรงต่อเนื่อง (ECIR) ไม่มีเงินคืน ${numeral(
                  HealthCheckPDF(balanceData)?.compensation_ecir
                ).format("0,0")} บาท `}{" "}
                    </div>{" "}
                    <div className="!font-medium ">
                      {`
                ค่าชดเชยโรคร้ายแรง (AIA Supercare) มีเงินคืน ${numeral(
                  HealthCheckPDF(balanceData)?.compensation_aia_supercare
                ).format("0,0")} บาท `}{" "}
                    </div>{" "}
                    <div className="!font-medium ">
                      {`
                ค่าชดเชยโรคร้ายแรง (AIA ProCare) มีเงินคืน ${numeral(
                  HealthCheckPDF(balanceData)?.compensation_aia_procare
                ).format("0,0")} บาท `}{" "}
                    </div>{" "}
                    <div className="!font-medium ">
                      {`
                ค่าชดเชยโรยร้ายแรง (AIA CI Plus Gold) ไม่มีเงินคืน ${numeral(
                  HealthCheckPDF(balanceData)?.compensation_aia_ci_plus_gold
                ).format("0,0")} บาท `}{" "}
                    </div>{" "}
                    <div className="!font-medium ">
                      {`
                ค่าชดเชยโรยร้ายแรง (AIA CI Plus) ไม่มีเงินคืน ${numeral(
                  HealthCheckPDF(balanceData)?.compensation_aia_ci_plus
                ).format("0,0")} บาท `}{" "}
                    </div>{" "}
                    <div className="!font-medium ">
                      {`
                ค่าชดเชยโรยร้ายแรง (Mutiple Care CI) ไม่มีเงินคืน ${numeral(
                  HealthCheckPDF(balanceData)?.compensation_mutiple_care_ci
                ).format("0,0")} บาท `}{" "}
                    </div>{" "}
                    <div className="!font-medium ">
                      {`
                ประกันภัยโรคร้ายแรงแบบซีไอรายปี ${numeral(
                  HealthCheckPDF(balanceData)
                    ?.critical_illness_insurance_yearly_ci
                ).format("0,0")} บาท `}{" "}
                    </div>{" "}
                    <div className={"flex flex-wrap justify-start"}>
                      ควรทบทวนประกันสุขภาพว่ามีเพียงพอหรือไม่ ถ้ายังไม่เพียงพอ
                      เบี้ยประกันสุขภาพหลักพัน คุ้มครองหลักแสน
                    </div>
                  </div>
                )
              }
              onClick={() => {
                navigate("/insuranceplan/disabled");
              }}
            />
            <CardGrayMenu
              img={"../images/sick_insuarance_all.png"}
              title={"ประกันสุขภาพ"}
              title2={
                Number(
                  HealthCheckPDF(balanceData)?.treatmentSurgery +
                    HealthCheckPDF(balanceData)?.treatmentSurgeryLumpSum +
                    HealthCheckPDF(balanceData)?.compensationtreatment +
                    HealthCheckPDF(balanceData)?.compensationtreatmentSpacial
                ) <= 0 ? (
                  <>
                    <div className="text-start">
                      {`คุณลืมกรอกข้อมูลค่าเบี้ยประกันชีวิตหรือไม่ ถ้าคุณไม่ได้ซื้อประกันสุขภาพ หากเกิดเหตุไม่คาดฝันขึ้นมา เจ็บป่วยครั้งเดียวแทบหมดตัว  เบี้ยประกันสุขภาพหลักพัน คุ้มครองหลักแสน เบี้ยประกันหลักหมื่นคุ้มครองหลักล้าน`}
                    </div>
                    <div>{`**กรอกข้อมูลได้ที่รายจ่ายคงที่ > ค่าเบี้ยประกันชีวิตรายปี > รายละเอียดเพิ่มเติม > ตามข้อมูลที่มีดอกจัน 2 ดอก**`}</div>
                  </>
                ) : (
                  <div className="flex flex-col items-start ">
                    <div className="!font-medium ">{`การรักษาในโรงพยาบาลและศัลยกรรม  ${numeral(
                      HealthCheckPDF(balanceData)?.treatmentSurgery
                    ).format("0,0")} บาท   `}</div>{" "}
                    <div className="!font-medium ">
                      {`
                การรักษาในโรงพยาบาลและศัลยกรรมแบบเหมาจ่าย  ${numeral(
                  HealthCheckPDF(balanceData)?.treatmentSurgeryLumpSum
                ).format("0,0")} บาท `}{" "}
                    </div>{" "}
                    <div className="!font-medium ">{`
                ค่าชดเชยรายวันในการเข้ารักษาตัวในโรงพยาบาล แบบพิเศษ    ${numeral(
                  HealthCheckPDF(balanceData)?.compensationtreatment
                ).format("0,0")} บาท `}</div>{" "}
                    <div className="!font-medium ">{`ค่าชดเชยรายวันในการเข้ารักษาตัวในโรงพยาบาล ${numeral(
                      HealthCheckPDF(balanceData)?.compensationtreatmentSpacial
                    ).format("0,0")}
                              บาท`}</div>
                    <div className={"flex flex-wrap justify-start"}>
                      ควรทบทวนประกันสุขภาพว่ามีเพียงพอหรือไม่ ถ้ายังไม่เพียงพอ
                      เบี้ยประกันสุขภาพหลักพัน คุ้มครองหลักแสน
                    </div>
                  </div>
                )
              }
              onClick={onClickToWebsite}
            />
            <CardGrayMenu
              img={"../images/risk_accident.svg"}
              title={"ประกันอุบัติเหตุ"}
              title2={
                hasAccidentInsurance ? (
                  <p>
                    ควรทบทวนกรมธรรม์ประกันอุบัติเหตุ
                    ว่ามีความคุ้มครองเพียงพอต่อความจำเป็นหรือไม่
                    เบี้ยหลักพันคุ้มครองหลักแสน
                    เบิกได้ทั้งอุบัติเหตุผู้ป่วยในและผู้ป่วยนอก รักษาจนกว่าจะหาย
                    ตามวงเงินประกัน <u>ดูรายละเอียดเพิ่มเติม</u>
                  </p>
                ) : (
                  <p>
                    ประกันอุบัติเหตุเบี้ยหลักพันต่อปีคุ้มครองหลักแสน
                    มีแล้วอุ่นใจ เบิกได้ทั้งอุบัติเหตุผู้ป่วยในและผู้ป่วยนอก
                    รักษาจนกว่าจะหาย ตามวงเงินประกัน{" "}
                    <u>ดูรายละเอียดเพิ่มเติม</u>
                  </p>
                )
              }
              onClick={onClickToWebsite}
            />
            <CardGrayMenu
              img={"../images/risk_fire.svg"}
              title2={
                hasFireInsurance ? (
                  <p>
                    ควรทบทวนกรมธรรม์ ประกันสินทรัพย์และอัคคีภัย
                    ว่าได้รับความคุ้มครองเหมาะสมกับมูลค่าสินทรัพย์ในปัจจุบันหรือไม่
                    มิฉะนั้นหากเกิดความเสียหายมา บริษัทจะจ่ายตามสัดส่วน
                    ไม่ใช่มูลค่าความเสียหายที่แท้จริง{" "}
                    <u>ดูรายละเอียดเพิ่มเติม</u>
                  </p>
                ) : (
                  <p>
                    สินทรัพย์ของคุณยังไม่มีการบริหารความเสี่ยงด้วยประกันอัคคีภัย
                    เบี้ยหลักพันคุ้มครองหลักล้าน <u>ดูรายละเอียดเพิ่มเติม</u>
                  </p>
                )
              }
              title={"ประกันสินทรัพย์อัคคีภัย"}
              onClick={onClickToWebsite}
            />
            <CardGrayMenu
              img={"../images/car_insuarance_all.png"}
              title2={
                hasCarInsurance ? (
                  <p>
                    ควรทบทวนกรมธรรม์ประกันอุบัติเหตุ
                    ว่ามีความคุ้มครองเพียงพอต่อความจำเป็นหรือไม่
                    เบี้ยหลักพันคุ้มครองหลักแสน
                    เบิกได้ทั้งอุบัติเหตุผู้ป่วยในและผู้ป่วยนอก รักษาจนกว่าจะหาย
                    ตามวงเงินประกัน <u>ดูรายละเอียดเพิ่มเติม</u>
                  </p>
                ) : (
                  <p>
                    คุณลืมกรอกข้อมูลค่าเบี้ยประกันรถยนต์หรือไม่
                    ถ้าคุณไม่ได้ซื้อประกันรถยนต์ภาคบังคับ/ภาคสมัครใจ
                    เกิดเหตุไม่คาดฝันขึ้นมา โดนฟ้องร้องหมดตัวเลยนะครับ
                    เบี้ยประกันภาคบังคับหลักร้อยต่อปีคุ้มครองหลักแสน
                    ประกันภาคสมัครใจ เบี้ยหลักพันคุ้มครองหลักแสน{" "}
                    <u>ดูรายละเอียดเพิ่มเติม</u>
                  </p>
                )
              }
              title={"ประกันรถยนต์"}
              onClick={onClickToWebsite}
            />
            <CardGrayMenu
              img={"../images/two_hearts.png"}
              title2={
                "แนะนำ ประกันชดเชยโรคร้ายแรง / ประกันการเดินทางต่างประเทศ และหากทำธุรกิจการศึกษาประกันภัยทางธุรกิจก็จำเป็น"
              }
              title={"ประกันอื่น ๆ"}
              onClick={onClickToWebsite}
            />
          </div>
        </div>
      </div>
    </Container>
  );
};

export default InsuarancePlanMain;
